<template>
  <div class="convey-connect-statistics" :class="isDarkMode ? 'dark' : ''">
    <div
      class="convey-connect-statistics--blocks row d-flex"
      style="flex-wrap: wrap; height: 100%"
      v-if="statsCount"
    >
      <div
        class="col-md-6 col-sm-6 col-xs-12 mb-3 col-lg-4 col-xl-4"
        style="height: 185px"
      >
        <b-card>
          <div class="d-flex justify-content-between align-items-center">
            <span class="card-title">Total Duration </span>
          </div>
          <p
            class="convey-connect-statistics--count"
            :class="isDarkMode ? 'count-dark' : ''"
          >
            {{
              statsCount.totalDuration && statsCount.totalDuration.total
                ? statsCount.totalDuration.total
                : 0
            }}
          </p>
          <div class="convey-connect-statistics--footer">
            <div class="d-flex justify-content-between">
              <b-link href="#" class="card-link"
                ><span
                  class="d-block"
                  style="font-weight: 400; color: #989898; font-size: 0.75rem"
                  >Avg Que Time</span
                >
                <span
                  style="font-weight: 700; font-size: 1.125rem; color: #1b59f8"
                  class="d-block"
                  >{{
                    statsCount.totalDuration &&
                    statsCount.totalDuration.averageQueTime
                      ? statsCount.totalDuration.averageQueTime
                      : 0
                  }}</span
                ></b-link
              >
            </div>
          </div>
        </b-card>
      </div>

      <div
        class="col-md-6 col-sm-6 col-xs-12 mb-3 col-lg-4 col-xl-4"
        style="height: 185px"
      >
        <b-card title="Total Calls">
          <p
            class="convey-connect-statistics--count"
            :class="isDarkMode ? 'count-dark' : ''"
          >
            {{
              statsCount.totalCalls && statsCount.totalCalls.totalCount
                ? statsCount.totalCalls.totalCount
                : 0
            }}
          </p>
          <div class="convey-connect-statistics--footer">
            <div class="d-flex justify-content-between">
              <b-link href="#" class="card-link"
                ><span
                  class="d-block"
                  style="font-weight: 500; color: #989898; font-size: 0.75rem"
                  >Audio</span
                >
                <span
                  style="font-weight: 700; font-size: 1.125rem; color: #1b59f8"
                  class="d-block text-center"
                  >{{
                    statsCount.totalCalls && statsCount.totalCalls.audioCount
                      ? statsCount.totalCalls.audioCount
                      : 0
                  }}</span
                ></b-link
              >
              <b-link href="#" class="card-link"
                ><span
                  class="d-block"
                  style="font-weight: 500; color: #989898; font-size: 0.75rem"
                  >Video</span
                >
                <span
                  style="font-weight: 700; font-size: 1.125rem; color: #1b59f8"
                  class="d-block text-center"
                  >{{
                    statsCount.totalCalls && statsCount.totalCalls.videoCount
                      ? statsCount.totalCalls.videoCount
                      : 0
                  }}</span
                ></b-link
              >
            </div>
          </div>
        </b-card>
      </div>
      <div
        class="col-md-6 col-sm-6 col-xs-12 mb-3 col-lg-4 col-xl-4"
        style="height: 185px"
      >
        <b-card title="Account Charges">
          <p
            class="convey-connect-statistics--count"
            :class="isDarkMode ? 'count-dark' : ''"
          >
            ${{
              statsCount.accountCharges && statsCount.accountCharges.totalCount
                ? statsCount.accountCharges.totalCount
                : 0
            }}
          </p>
          <div class="convey-connect-statistics--footer">
            <div class="d-flex justify-content-between">
              <b-link href="#" class="card-link"
                ><span
                  class="d-block"
                  style="font-weight: 500; color: #989898; font-size: 0.75rem"
                  >Audio</span
                >
                <span
                  style="font-weight: 700; font-size: 1.125rem; color: #1b59f8"
                  class="d-block text-center"
                  >${{
                    statsCount.accountCharges &&
                    statsCount.accountCharges.audioCount
                      ? statsCount.accountCharges.audioCount
                      : 0
                  }}</span
                ></b-link
              >
              <b-link href="#" class="card-link"
                ><span
                  class="d-block"
                  style="font-weight: 500; color: #989898; font-size: 0.75rem"
                  >Video</span
                >
                <span
                  style="font-weight: 700; font-size: 1.125rem; color: #1b59f8"
                  class="d-block text-center"
                  >${{
                    statsCount.accountCharges &&
                    statsCount.accountCharges.videoCount
                      ? statsCount.accountCharges.videoCount
                      : 0
                  }}</span
                ></b-link
              >
            </div>
          </div>
        </b-card>
      </div>

      <div
        class="col-md-6 col-sm-6 col-xs-12 mb-3 col-lg-4 col-xl-4"
        style="height: 185px"
      >
        <b-card>
          <div class="d-flex justify-content-between align-items-center">
            <span class="card-title">Call Quality Rating </span>
          </div>
          <p
            class="convey-connect-statistics--count"
            :class="isDarkMode ? 'count-dark' : ''"
          >
            {{
              statsCount.callQualityRating ? statsCount.callQualityRating : 0
            }}
          </p>
        </b-card>
      </div>

      <div
        class="col-md-6 col-sm-6 col-xs-12 mb-3 col-lg-4 col-xl-4"
        style="height: 185px"
      >
        <b-card title="Requester Rating">
          <p
            class="convey-connect-statistics--count"
            :class="isDarkMode ? 'count-dark' : ''"
          >
            {{
              statsCount.requesterRating ? statsCount.requesterRating.total : 0
            }}
            <sub style="bottom: -0.05em; font-size: 0.875rem; color: #9ea09e"
              >Avg
            </sub>
          </p>
          <div class="convey-connect-statistics--footer">
            <div id="requesterRatingChart"></div>
          </div>
        </b-card>
      </div>
      <div
        class="col-md-6 col-sm-6 col-xs-12 mb-3 col-lg-4 col-xl-4"
        style="height: 185px"
      >
        <b-card title="Interpreter rating">
          <p
            class="convey-connect-statistics--count"
            :class="isDarkMode ? 'count-dark' : ''"
          >
            {{
              statsCount.interpreterRating
                ? statsCount.interpreterRating.total
                : 0
            }}
            <sub style="bottom: -0.05em; font-size: 0.875rem; color: #9ea09e"
              >Avg</sub
            >
          </p>
          <div class="convey-connect-statistics--footer">
            <div id="interpreterRatingChart"></div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import ApexCharts from "apexcharts";

let requesterRatingChart = null;
let interpreterRatingChart = null;

export default {
  name: "convey-connect-statistics",
  data() {
    return {
      requesterRatingOptions: {
        chart: {
          height: 30,
          type: "area",
          sparkline: { enabled: true },
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        xaxis: {
          categories: [],
        },
        tooltip: {
          theme: this.isDarkMode ? "dark" : "light",
        },
      },
      interpreterRatingOptions: {
        chart: {
          height: 30,
          type: "area",
          sparkline: { enabled: true },
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        xaxis: {
          categories: [],
        },
        tooltip: {
          theme: this.isDarkMode ? "dark" : "light",
        },
      },
      series: {
        requesterRating: [],
        interpreterRating: [],
      },
    };
  },
  props: {
    statsCount: Object,
    isDarkMode: Boolean,
  },
  mounted() {
    this.getFormattedData();
    this.renderChart();
  },
  watch: {
    series(newVal, oldVal) {
      if (newVal !== oldVal) {
        requesterRatingChart.updateSeries(this.series.requesterRating);
        requesterRatingChart.updateOptions(this.requesterRatingOptions);

        interpreterRatingChart.updateSeries(this.series.interpreterRating);
        interpreterRatingChart.updateOptions(this.interpreterRatingOptions);
      }
    },
    statsCount(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getFormattedData();
      }
    },
    isDarkMode(newVal, oldVal) {
      if (newVal !== oldVal) {
        requesterRatingChart.updateOptions({
          tooltip: {
            theme: newVal === true ? "dark" : "light",
          },
        });

        interpreterRatingChart.updateOptions({
          tooltip: {
            theme: newVal === true ? "dark" : "light",
          },
        });
      }
    },
  },
  methods: {
    getFormattedData() {
      this.series = {
        requesterRating: [
          {
            name: "Count",
            data:
              this.statsCount.requesterRating &&
              this.statsCount.requesterRating.graphData
                ? [...this.statsCount.requesterRating.graphData]
                : [],
            color: "#608bfa",
          },
        ],
        interpreterRating: [
          {
            name: "Count",
            data:
              this.statsCount.interpreterRating &&
              this.statsCount.interpreterRating.graphData
                ? [...this.statsCount.interpreterRating.graphData]
                : [],
            color: "#608bfa",
          },
        ],
      };
    },
    renderChart() {
      requesterRatingChart = new ApexCharts(
        document.querySelector("#requesterRatingChart"),
        {
          ...this.requesterRatingOptions,
          series:
            this.series && this.series.requesterRating
              ? this.series.requesterRating
              : [],
        }
      );
      requesterRatingChart.render();

      interpreterRatingChart = new ApexCharts(
        document.querySelector("#interpreterRatingChart"),
        {
          ...this.interpreterRatingOptions,
          series:
            this.series && this.series.interpreterRating
              ? this.series.interpreterRating
              : [],
        }
      );
      interpreterRatingChart.render();
    },
    goToRecentCalls() {},
  },
  beforeDestroy() {
    if (requesterRatingChart) {
      requesterRatingChart.destroy();
    }
    if (interpreterRatingChart) {
      interpreterRatingChart.destroy();
    }
  },
};
</script>
<style lang="scss">
.convey-connect-statistics {
  &--blocks {
    &.row {
      margin: 0 -0.5rem !important;
      > * {
        padding: 0 0.5rem !important;
      }
    }
  }
  & .card {
    height: 100%;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 0%), 0 6px 20px 0 rgb(0 0 0 / 12%);
    border-radius: 1rem;
  }
  & .card-title {
    font-size: 0.875rem;
    text-align: left;
    color: rgba(0, 0, 0, 0.7);
    font-weight: 500;
    margin-bottom: 0;
  }
  &--count {
    position: absolute;
    text-align: left;
    font-size: 1.6rem;
    font-weight: 700;
    margin-bottom: 0;
    top: 36%;
    color: rgba(0, 0, 0, 1);
  }
  & .count-dark {
    color: #b2b9bf !important;
  }
  &--footer {
    position: absolute;
    bottom: 15px;
    width: 100%;
    left: 0;
    padding: 0 16px;
  }
  &--item {
    flex-basis: 33%;
    box-sizing: border-box;
  }
  &--view-more-vertical {
    &.show {
      & .dropdown-toggle {
        background-color: transparent !important;
        color: #6b7980;
        border: none;
        padding: 0;
      }
    }
    & .dropdown-toggle {
      background-color: transparent !important;
      color: #6b7980;
      border: none;
      padding: 0;
      &:active,
      &.active {
        background-color: transparent !important;
        color: #6b7980 !important;
        border: none !important;
      }
      &::after {
        display: none;
      }
    }
    & .dropdown-menu {
      padding: 0;
    }
  }
}

.convey-connect-statistics.dark {
  & .card-title {
    color: #b2b9bf !important;
  }
}
</style>